import { ARBITRUM, ARBITRUM_TESTNET, AVALANCHE, MAINNET, TESTNET, FANTOM, MUMBAI, OP, BASE, FANTOM_TEST } from "./chains";

export const XGMT_EXCLUDED_ACCOUNTS = [
  "0x330eef6b9b1ea6edd620c825c9919dc8b611d5d5",
  "0xd9b1c23411adbb984b1c4be515fafc47a12898b2",
  "0xa633158288520807f91ccc98aa58e0ea43acb400",
  "0xffd0a93b4362052a336a7b22494f1b77018dd34b",
];

const CONTRACTS = {
  [MAINNET]: {
    // bsc mainnet
    Treasury: "0xa44E7252a0C137748F523F112644042E5987FfC7",
    BUSD: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    GMT: "0x99e92123eB77Bc8f999316f622e5222498438784",
    Vault: "0xc73A8DcAc88498FD4b4B1b2AaA37b0a2614Ff67B",
    Router: "0xD46B23D042E976F8666F554E928e0Dc7478a8E1f",
    Reader: "0x087A618fD25c92B61254DBe37b09E5E8065FeaE7",
    AmmFactory: "0xBCfCcbde45cE874adCB698cC183deBcF17952812",
    AmmFactoryV2: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
    OrderBook: "0x1111111111111111111111111111111111111111",
    OrderBookReader: "0x1111111111111111111111111111111111111111",
    GmxMigrator: "0xDEF2af818514c1Ca1A9bBe2a4D45E28f260063f9",
    USDG: "0x85E76cbf4893c1fbcB34dCF1239A91CE2A4CF5a7",
    NATIVE_TOKEN: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    XGMT: "0xe304ff0983922787Fd84BC9170CD21bF78B16B10",
    GMT_USDG_PAIR: "0xa41e57459f09a126F358E118b693789d088eA8A0",
    XGMT_USDG_PAIR: "0x0b622208fc0691C2486A3AE6B7C875b4A174b317",
    GMT_USDG_FARM: "0x3E8B08876c791dC880ADC8f965A02e53Bb9C0422",
    XGMT_USDG_FARM: "0x68D7ee2A16AB7c0Ee1D670BECd144166d2Ae0759",
    USDG_YIELD_TRACKER: "0x0EF0Cf825B8e9F89A43FfD392664131cFB4cfA89",
    XGMT_YIELD_TRACKER: "0x82A012A9b3003b18B6bCd6052cbbef7Fa4892e80",
    GMT_USDG_FARM_TRACKER_XGMT: "0x08FAb024BEfcb6068847726b2eccEAd18b6c23Cd",
    GMT_USDG_FARM_TRACKER_NATIVE: "0xd8E26637B34B2487Cad1f91808878a391134C5c2",
    XGMT_USDG_FARM_TRACKER_XGMT: "0x026A02F7F26C1AFccb9Cba7C4df3Dc810F4e92e8",
    XGMT_USDG_FARM_TRACKER_NATIVE: "0x22458CEbD14a9679b2880147d08CA1ce5aa40E84",
    AUTO: "0xa184088a740c695E156F91f5cC086a06bb78b827",
    AUTO_USDG_PAIR: "0x0523FD5C53ea5419B4DAF656BC1b157dDFE3ce50",
    AUTO_USDG_FARM: "0xE6958298328D02051769282628a3b4178D0F3A47",
    AUTO_USDG_FARM_TRACKER_XGMT: "0x093b8be41c1A30704De84a9521632f9a139c08bd",
    AUTO_USDG_FARM_TRACKER_NATIVE: "0x23ed48E5dce3acC7704d0ce275B7b9a0e346b63A",
    GMT_GMX_IOU: "0x47052469970C2484729875CC9E2dd2683fcE71fb",
    XGMT_GMX_IOU: "0xeB3733DFe3b68C9d26898De2493A3Bb59FDb4A7B",
    GMT_USDG_GMX_IOU: "0x481312655F81b5e249780A6a49735335BF6Ca7f4",
    XGMT_USDG_GMX_IOU: "0x8095F1A92526C304623483018aA28cC6E62EB1e1",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
  },
  [TESTNET]: {
    // bsc testnet
    Vault: "0x1B183979a5cd95FAF392c8002dbF0D5A1C687D9a",
    Router: "0x10800f683aa564534497a5b67F45bE3556a955AB",
    Reader: "0x98D4742F1B6a821bae672Cd8721283b91996E454",
    AmmFactory: "0x6725f303b657a9451d8ba641348b6761a6cc7a17",
    AmmFactoryV2: "0x1111111111111111111111111111111111111111",
    OrderBook: "0x9afD7B4f0b58d65F6b2978D3581383a06b2ac4e9",
    OrderBookReader: "0x0713562970D1A802Fa3FeB1D15F9809943982Ea9",
    GmxMigrator: "0xDEF2af818514c1Ca1A9bBe2a4D45E28f260063f9",
    USDG: "0x2D549bdBf810523fe9cd660cC35fE05f0FcAa028",
    GMT: "0xedba0360a44f885ed390fad01aa34d00d2532817",
    NATIVE_TOKEN: "0x612777Eea37a44F7a95E3B101C39e1E2695fa6C2",
    XGMT: "0x28cba798eca1a3128ffd1b734afb93870f22e613",
    GMT_USDG_PAIR: "0xe0b0a315746f51932de033ab27223d85114c6b85",
    XGMT_USDG_PAIR: "0x0108de1eea192ce8448080c3d90a1560cf643fa0",
    GMT_USDG_FARM: "0xbe3cB06CE03cA692b77902040479572Ba8D01b0B",
    XGMT_USDG_FARM: "0x138E92195D4B99CE3618092D3F9FA830d9A69B4b",
    USDG_YIELD_TRACKER: "0x62B49Bc3bF252a5DB26D88ccc7E61119e3179B4f",
    XGMT_YIELD_TRACKER: "0x5F235A582e0993eE9466FeEb8F7B4682993a57d0",
    GMT_USDG_FARM_TRACKER_XGMT: "0x4f8EE3aE1152422cbCaFACd4e3041ba2D859913C",
    GMT_USDG_FARM_TRACKER_NATIVE: "0xd691B26E544Fe370f39A776964c991363aF72e56",
    XGMT_USDG_FARM_TRACKER_XGMT: "0xfd5617CFB082Ba9bcD62d654603972AE312bC695",
    XGMT_USDG_FARM_TRACKER_NATIVE: "0x0354387DD85b7D8aaD1611B3D167A384d6AE0c28",
    GMT_GMX_IOU: "0x47052469970C2484729875CC9E2dd2683fcE71fb",
    XGMT_GMX_IOU: "0xeB3733DFe3b68C9d26898De2493A3Bb59FDb4A7B",
    GMT_USDG_GMX_IOU: "0x481312655F81b5e249780A6a49735335BF6Ca7f4",
    XGMT_USDG_GMX_IOU: "0x8095F1A92526C304623483018aA28cC6E62EB1e1",
    PositionRouter: "0x0000000000000000000000000000000000000000",
    PositionManager: "0x0000000000000000000000000000000000000000",

    // UniswapGmxEthPool: "0x80A9ae39310abf666A87C743d6ebBD0E8C42158E",
    ReferralStorage: "0x0000000000000000000000000000000000000000",
    ReferralReader: "0x0000000000000000000000000000000000000000",
    VaultReader: "0x0000000000000000000000000000000000000000",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
    MMYLP: "0x0000000000000000000000000000000000000000"
  },
  [ARBITRUM_TESTNET]: {
    // arbitrum testnet
    Vault: "0xBc9BC47A7aB63db1E0030dC7B60DDcDe29CF4Ffb",
    Router: "0xe0d4662cdfa2d71477A7DF367d5541421FAC2547",
    VaultReader: "0xFc371E380262536c819D12B9569106bf032cC41c",
    Reader: "0x2E093c70E3A7E4919611d2555dFd8D697d2fC0a1",
    GlpManager: "0xD875d99E09118d2Be80579b9d23E83469077b498",
    RewardRouter: "0x0000000000000000000000000000000000000000",
    RewardReader: "0x0000000000000000000000000000000000000000",
    NATIVE_TOKEN: "0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681",
    GLP: "0xb4f81Fa74e06b5f762A104e47276BA9b2929cb27",
    GMX: "0x0000000000000000000000000000000000000000",
    ES_GMX: "0x0000000000000000000000000000000000000000",
    BN_GMX: "0x0000000000000000000000000000000000000000",
    USDG: "0xBCDCaF67193Bf5C57be08623278fCB69f4cA9e68",
    ES_GMX_IOU: "0x0000000000000000000000000000000000000000",
    StakedGmxTracker: "0x0000000000000000000000000000000000000000",
    BonusGmxTracker: "0x0000000000000000000000000000000000000000",
    FeeGmxTracker: "0x0000000000000000000000000000000000000000",
    StakedGlpTracker: "0x0000000000000000000000000000000000000000",
    FeeGlpTracker: "0x0000000000000000000000000000000000000000",

    StakedGmxDistributor: "0x0000000000000000000000000000000000000000",
    StakedGlpDistributor: "0x0000000000000000000000000000000000000000",

    GmxVester: "0x0000000000000000000000000000000000000000",
    GlpVester: "0x0000000000000000000000000000000000000000",

    OrderBook: "0xebD147E5136879520dDaDf1cA8FBa48050EFf016",
    OrderBookReader: "0xC492c8d82DC576Ad870707bb40EDb63E2026111E",

    PositionRouter: "0xB4bB78cd12B097603e2b55D2556c09C17a5815F8",
    PositionManager: "0x168aDa266c2f10C1F37973B213d6178551030e44",

    // UniswapGmxEthPool: "0x80A9ae39310abf666A87C743d6ebBD0E8C42158E",
    ReferralStorage: "0x0000000000000000000000000000000000000000",
    ReferralReader: "0x0000000000000000000000000000000000000000",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
    MMYLP: "0x0000000000000000000000000000000000000000"
  },
  [ARBITRUM]: {
    // arbitrum mainnet
    VaultMMY: "0xe0Ab0b3d621A38137514D2359D9Ca6c3c4610Ca5",
    VaultMLP: "0x3f83F08c51522F142dD8056c1468bFAcec619e3e",
    VaultMMY_WFTM: "???",
    VaultMMY_WETH: "???",
    Vault: "0x304951d7172bCAdA54ccAC1E4674862b3d5b3d5b",
    Router: "0x01e9B35785eF3f7Ef2677c371442976bd550f320",
    VaultReader: "0x7B26207457A9F8fF4fd21A7A0434066935f1D8E7",
    Reader: "0x04f23404553fcc388Ec73110A0206Dd2E76a6d95",
    GlpManager: "0x65DCb38637b526305Be55F14B24a4Ab2bD177780",
    RewardRouter: "0x766257B7cE3a5E3Ad5876200Ab1671D31289BC75",
    RewardReader: "0xe149164D8eca659E8912DbDEC35E3f7E71Fb5789",
    NATIVE_TOKEN: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    GLP: "0x41cD8CaFc24A771031B9eB9C57cFC94D86045eB6",
    GMX: "0xA6D7D0e650aa40FFa42d845A354c12c2bc0aB15f",
    ES_GMX: "0x68d1CA32Aee9a73534429D8376743Bf222ff1870",
    BN_GMX: "0x2D270f66feE6Ac9e27Ff6551AF5a8cFB5C8a7493",
    USDG: "0x9032aeD8C1F2139E04C1AD6D9F75bdF1D6e5CF5c",
    ES_GMX_IOU: "0x0000000000000000000000000000000000000000",
    StakedGmxTracker: "0x52cC60893d3Bd8508baAB835620CbF9ddfA0A13C",
    BonusGmxTracker: "0xCEBC8A8b66De9B3f4393966EaB86Fc9DE26B2529",
    FeeGmxTracker: "0xA30b1C3c8EDE3841dE05F9CdD4D0e097aC4C6D92",
    StakedGlpTracker: "0xad96D9736484e35985773bdf7dBa5750dC830042",
    FeeGlpTracker: "0xa0207802B0953b17421bf9Cb10B3ACf5823496ab",

    StakedGmxDistributor: "0xa1a65D3639A1EFbFB18C82003330a4b1FB620C5a",
    StakedGlpDistributor: "0xfDC9B5be032216315bBe8c06b1c4F563D1689b85",

    GmxVester: "0xb471865C97a271E1572EcCA838b971E710498e4c",
    GlpVester: "0x3C05Ad1Ba92906dB8b9F3dB03c4C4D5119cE4110",
    GmxVesterV1: "0x0000000000000000000000000000000000000000",
    GlpVesterV1: "0x0000000000000000000000000000000000000000",

    OrderBook: "0x08Dfcfb0bD6e7eAF828f60021C77d273DE56b1C5",
    OrderExecutor: "0x0000000000000000000000000000000000000000",
    OrderBookReader: "0x727dB8FA7861340d49d13ea78321D0C9a1a79cd5",

    PositionRouter: "0x3B2732c1e5A248BBDD0315E9e8845c64f5A6FaF5",
    PositionManager: "0x198634D01A8E1646faE8676904343c33b1d2C6b9",

    UniswapGmxEthPool: "0x694d94AcafA4494Ab532c5ac7b89aB243d91dd52",
    ReferralStorage: "0xC2C5968e16ec9fABc39e27f9AbFC07C8Cfba6F16",
    ReferralReader: "0xFfB69477FeE0DAEB64E7dE89B57846aFa990e99C",
    NFTClub: "0x8BB0f8C2815924F195c1a86D6fe21fafac6F8c45",
    MummyClubSale: "0x0000000000000000000000000000000000000000",
    MummyClubStaking: "0xe092037623667d0d9d3e0a07ea9c607bdfa56155",
    MummyClubStakingV2: "0x0000000000000000000000000000000000000000",
    Multicall: "0xcA11bde05977b3631167028862bE2a173976CA11",
    Bridge: "0xA6D7D0e650aa40FFa42d845A354c12c2bc0aB15f",
    MMYMigration: "0x0000000000000000000000000000000000000000",
    MigrateVester: "0x0000000000000000000000000000000000000000",
    BridgeNFT: "0x8BB0f8C2815924F195c1a86D6fe21fafac6F8c45",
    NFTSaleV2: "0x4f1B6191fD7EE88375E28d87F738bb5772f0C877",
    NFTClubV2: "0xec866016ce430654d823f682491462a2be39014c",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
    MultiFeeDistribution: "0xBEb742e42481A329bf160C922Ba5309Bb9F8a86D",
    ChefIncetives: "0x5c6C987936539034930CD00fCD8c9Ab8b3458560",
    MMYLP: "0x0000000000000000000000000000000000000000"
  },
  [AVALANCHE]: {
    // avalanche
    Vault: "0x9ab2De34A33fB459b538c43f251eB825645e8595",
    Router: "0x5F719c2F1095F7B9fc68a68e35B51194f4b6abe8",
    VaultReader: "0x66eC8fc33A26feAEAe156afA3Cb46923651F6f0D",
    Reader: "0x2eFEE1950ededC65De687b40Fd30a7B5f4544aBd",
    GlpManager: "0xe1ae4d4b06A5Fe1fc288f6B4CD72f9F8323B107F",
    RewardRouter: "0x82147C5A7E850eA4E28155DF107F2590fD4ba327",
    RewardReader: "0x04Fc11Bd28763872d143637a7c768bD96E44c1b6",
    NATIVE_TOKEN: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    GLP: "0x01234181085565ed162a948b6a5e88758CD7c7b8",
    GMX: "0x62edc0692BD897D2295872a9FFCac5425011c661",
    ES_GMX: "0xFf1489227BbAAC61a9209A08929E4c2a526DdD17",
    BN_GMX: "0x8087a341D32D445d9aC8aCc9c14F5781E04A26d2",
    USDG: "0xc0253c3cC6aa5Ab407b5795a04c28fB063273894",
    ES_GMX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder address

    StakedGmxTracker: "0x2bD10f8E93B3669b6d42E74eEedC65dd1B0a1342",
    BonusGmxTracker: "0x908C4D94D34924765f1eDc22A1DD098397c59dD4",
    FeeGmxTracker: "0x4d268a7d4C16ceB5a606c173Bd974984343fea13",
    StakedGlpTracker: "0x9e295B5B976a184B14aD8cd72413aD846C299660",
    FeeGlpTracker: "0xd2D1162512F927a7e282Ef43a362659E4F2a728F",

    StakedGmxDistributor: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
    StakedGlpDistributor: "0xDd593Cf40734199afc9207eBe9ffF23dA4Bf7720",

    GmxVester: "0x472361d3cA5F49c8E633FB50385BfaD1e018b445",
    GlpVester: "0x62331A7Bd1dfB3A7642B7db50B5509E57CA3154A",

    OrderBook: "0x4296e307f108B2f583FF2F7B7270ee7831574Ae5",
    OrderExecutor: "0x4296e307f108B2f583FF2F7B7270ee7831574Ae5",
    OrderBookReader: "0xccFE3E576f8145403d3ce8f3c2f6519Dae40683B",

    PositionRouter: "0xffF6D276Bc37c61A23f06410Dce4A400f66420f8",
    PositionManager: "0xA21B83E579f4315951bA658654c371520BDcB866",

    TraderJoeGmxAvaxPool: "0x0c91a070f862666bbcce281346be45766d874d98",
    ReferralStorage: "0x827ed045002ecdabeb6e2b0d1604cf5fc3d322f8",
    ReferralReader: "0x505Ce16D3017be7D76a7C2631C0590E71A975083",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
    MMYLP: "0x0000000000000000000000000000000000000000"
  },
  [FANTOM]: {
    Vault: "0x7e9E9d925846B110B025041cfdF9942f2C401F4F",
    VaultMMY: "0x6b357844C40EA317bf9a214a93FFf72C658DDd03",
    VaultMLP: "0x29C7b5dC2F24DD26D3962cbCD75A7122bd1706D8",
    VaultMMY_WFTM_OLD: "0x0E3fE9D47c8db3ae68092c942D759BdCDde7eb3A",
    VaultMMY_WFTM: "0x6448600794C29c0B78710c2b12FF3728C9c91c71",
    VaultMMY_WETH: "???",
    Router: "0x6b4E5cbCED6E907Ab8525d83Dd3Cd9Ec6BDb62C4",
    VaultReader: "0x67B8a4A528A0a697491988B12EFbE865f9f20E18",
    Reader: "0xb5546535a3181d24F1e0cea032c696a92407bd4F",
    GlpManager: "0xca057751eDa4FB5BD23766C165555AD12A042202",
    RewardRouter: "0x0ccB273CA9842855636A6aC15bea105Ca05b20c4",
    RewardReader: "0x53418e5D25d1E4Ff176C28866A12b2fC546c357A",
    NATIVE_TOKEN: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83", //
    GLP: "0xAd41EC9dbCd9B4bD59d5EEF3E2be2cB8AAfc5e7e",
    GMX: "0x01e77288b38b416F972428d562454fb329350bAc",
    ES_GMX: "0xe41c6c006De9147FC4c84b20cDFBFC679667343F",
    BN_GMX: "0xc7CcA5b6EDC3e2ca3Bae2CCdf6bc4eCA943B7598",
    USDG: "0xd60aeF040e04a1F6b5f33078F18DD580B9A3f3C7",
    ES_GMX_IOU: "0x0000000000000000000000000000000000000000", //
    StakedGmxTracker: "0x2301d1AF7f00FfF41F8ecb250eee399972d23530",
    BonusGmxTracker: "0x2a6da5A53aFD235Ffb0A3569f0AeA841E6Fdc8F2",
    FeeGmxTracker: "0xC52Be971c10f2Ef8d34ED7C5E997dda1705cc292",
    StakedGlpTracker: "0xC35208A29EF948395db0F7e58A9C3293a6f42EB5",
    FeeGlpTracker: "0x11fe19BaBaA706D7B45f54e9F0231b7BA1DB9E4A",

    StakedGmxDistributor: "0x42E0fBa31503DD5c223006eD46bb1Cf25Bf1cd3a",
    StakedGlpDistributor: "0xe91e9279d89f508E8070801df13754304b86EbCE",

    GmxVester: "0x8eF5634F5C6Ef625302Ab6e4C424Dbe6B59496C0",
    GlpVester: "0xDdeaC5Dc3A5352cCa9dD13C3067Cbbdbe2A43700",
    GmxVesterV1: "0xa1a65D3639A1EFbFB18C82003330a4b1FB620C5a",
    GlpVesterV1: "0x2A3E489F713ab6F652aF930555b5bb3422711ac1",

    OrderBook: "0xf564737Ba16695c4a2733Ba9EdDf215D60d9a557",
    OrderExecutor: "0x0000000000000000000000000000000000000000", //
    OrderBookReader: "0xDf933efE492E54D0e7b99b6FD80A37906Ad0E98e",

    PositionRouter: "0x1cA552b930723f5d9CEDD56DBa53F3545215c7a3",
    PositionManager: "0xf342404561D8Ee0364F519aBCd7F18353D20ff5c",

    UniswapGmxEthPool: "0x2A6538a456650Cd454Dcd8f0B4665183DBa0bb27", //
    ReferralStorage: "0xd1FeA2883728330079bB6A6F1c6D332fCf764bAa",
    ReferralReader: "0x9e82f29a0f30584D9A92e93371234B807047c273",
    NFTClub: "0x573235B8e2708C39DD2Fa9Ec2d880121f4F83cA9",
    MummyClubSale: "0x6983249cFBE49eBD2c7fD37d392d69F1aEbE2d11",
    Multicall: "0xb828C456600857abd4ed6C32FAcc607bD0464F4F",
    MummyClubStaking: "0xD8e6AF2bE7A928F075a02a32eb65F2B7DfB696ad",
    MummyClubStakingV2: "0x7B25fA4AC6871CcdC2f29451ee0fa6eA01399968",
    LiquidityLocker: "0xcd6Fc0f32Eee391Ec4685c6c2E5c20A19960A804",
    Bridge: "0x4EE33bF422690B38552ec2A39dd942043C944ae8",
    MMYMigration: "0x0000000000000000000000000000000000000000",
    MigrateVester: "0x789eB395b830842c2E091c0B200C69D8c5Bb3D5a",
    BridgeNFT: "0xA6D7D0e650aa40FFa42d845A354c12c2bc0aB15f",
    NFTClubV2: "0x4964795d3F320C4BbfdAA0686a7629Cf92A4B266",
    NFTSaleV2: "0xf93a3F5488836b69735895c1C7843D5AF20CD8DE",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
    MultiFeeDistribution: "0xBEb742e42481A329bf160C922Ba5309Bb9F8a86D",
    MMYLP: "0x0000000000000000000000000000000000000000",
    ChefIncetives: "0x5c6C987936539034930CD00fCD8c9Ab8b3458560",
  },
  [OP]: {
    Vault: "0xA6D7D0e650aa40FFa42d845A354c12c2bc0aB15f",
    VaultMMY: "???",
    VaultMLP: "???",
    VaultMMY_WFTM: "???",
    VaultMMY_WETH: "0x27F59c92e26EA651370A4f18ab6DA5B7C3458586",
    Router: "0x68d1CA32Aee9a73534429D8376743Bf222ff1870",
    VaultReader: "0xc592b3ADd24ea30c030978e5E7F5d02E123b4263",
    Reader: "0x4C4d81aA29fBb7Fe90172ad70a72F00Fb1ee46c6",
    GlpManager: "0x9032aeD8C1F2139E04C1AD6D9F75bdF1D6e5CF5c",
    RewardRouter: "0xD451ffD204906C1A725c65eFE570Ad8a6e2B08Bd",
    RewardReader: "0x766257B7cE3a5E3Ad5876200Ab1671D31289BC75",
    NATIVE_TOKEN: "0x4200000000000000000000000000000000000006",
    GLP: "0xCaB2C0A41556149330F4223C9b76d93C610DAfE6",
    GMX: "0x385719545Ef34d457A88e723504544A53F0Ad9BC",
    ES_GMX: "0x0d8393CEa30df4fAFA7f00f333A62DeE451935C1",
    BN_GMX: "0x641Ff5D17178C3B9498133eBC264Bb4170A04668",
    USDG: "0x01e77288b38b416F972428d562454fb329350bAc",
    ES_GMX_IOU: "0x0000000000000000000000000000000000000000", // placeholder address

    StakedGmxTracker: "0x04f23404553fcc388Ec73110A0206Dd2E76a6d95",
    BonusGmxTracker: "0xe149164D8eca659E8912DbDEC35E3f7E71Fb5789",
    FeeGmxTracker: "0x7B26207457A9F8fF4fd21A7A0434066935f1D8E7",
    StakedGlpTracker: "0xC2C5968e16ec9fABc39e27f9AbFC07C8Cfba6F16",
    FeeGlpTracker: "0xFfB69477FeE0DAEB64E7dE89B57846aFa990e99C",

    StakedGmxDistributor: "0x52cC60893d3Bd8508baAB835620CbF9ddfA0A13C",
    StakedGlpDistributor: "0xad96D9736484e35985773bdf7dBa5750dC830042",

    GmxVester: "0x4F697DeDF2b3862CA43493c33589F42CFEF66026",
    GlpVester: "0xA25d432ae720e57e85778905935A9A0B9284114A",
    GmxVesterV1: "0x2A3E489F713ab6F652aF930555b5bb3422711ac1",
    GlpVesterV1: "0xb54AbE3FEC8e1aE64620185A1E111Aa0c3a81542",
    OrderBook: "0x41cD8CaFc24A771031B9eB9C57cFC94D86045eB6",
    OrderExecutor: "0x0000000000000000000000000000000000000000",
    OrderBookReader: "0xB2a477C6BA5E96f6dECbCEd836cB7d3d32ef9ecD",

    PositionRouter: "0xC5129208cb1DC2b3c916011c9D94632e602B9811",
    PositionManager: "0x2D270f66feE6Ac9e27Ff6551AF5a8cFB5C8a7493",

    TraderJoeGmxAvaxPool: "0x104D0312f95A1B3056435d19668f2272ab1e7dF2",
    ReferralStorage: "0x727dB8FA7861340d49d13ea78321D0C9a1a79cd5",
    ReferralReader: "0x28cfD8e1E83beC8EE879d21634e7DC3D93102CED",

    UniswapGmxEthPool: "0x5d2D9deE001D95Dc6B203d74AA651b6D864a619A", //
    NFTClub: "0x04AA94F9e529645B2Cf65027Ef45FeD47a3Cff66",
    MummyClubSale: "0x3C05Ad1Ba92906dB8b9F3dB03c4C4D5119cE4110",
    Multicall: "0xeAa6877139d436Dc6d1f75F3aF15B74662617B2C",
    MummyClubStaking: "0xd94452957bC47bc59985013BC087AD5a55f251aC",
    MummyClubStakingV2: "0x0000000000000000000000000000000000000000",
    LiquidityLocker: "0x0000000000000000000000000000000000000000",
    Bridge: "0x385719545Ef34d457A88e723504544A53F0Ad9BC",
    MMYMigration: "0x8082B086A8cD851A9690a03070e82737f37A548A",
    MigrateVester: "0x511A4CEf565FB8094fb71E7Ce735bC578cB57B86",
    BridgeNFT: "0x57f67286B6D1cE0623766022bCc2fAfE80B32c9a",
    NFTSaleV2: "0x4f1B6191fD7EE88375E28d87F738bb5772f0C877",
    NFTClubV2: "0xec866016ce430654d823f682491462a2be39014c",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
    MultiFeeDistribution: "0xBEb742e42481A329bf160C922Ba5309Bb9F8a86D",
    MMYLP: "0x0000000000000000000000000000000000000000",
    ChefIncetives: "0x5c6C987936539034930CD00fCD8c9Ab8b3458560",
  },
  [BASE]: {
    Vault: "0xA6D7D0e650aa40FFa42d845A354c12c2bc0aB15f",
    VaultMMY: "???",
    VaultMLP: "???",
    VaultMMY_WFTM: "???",
    VaultMMY_WETH: "???",
    Router: "0x65DCb38637b526305Be55F14B24a4Ab2bD177780",
    VaultReader: "0x04f23404553fcc388Ec73110A0206Dd2E76a6d95",
    Reader: "0x28cfD8e1E83beC8EE879d21634e7DC3D93102CED",
    GlpManager: "0x2D270f66feE6Ac9e27Ff6551AF5a8cFB5C8a7493",
    RewardRouter: "0xB2a477C6BA5E96f6dECbCEd836cB7d3d32ef9ecD",
    RewardReader: "0x727dB8FA7861340d49d13ea78321D0C9a1a79cd5",
    NATIVE_TOKEN: "0x4200000000000000000000000000000000000006",//
    GLP: "0x304951d7172bCAdA54ccAC1E4674862b3d5b3d5b",
    GMX: "0x0d8393CEa30df4fAFA7f00f333A62DeE451935C1",
    ES_GMX: "0x9032aeD8C1F2139E04C1AD6D9F75bdF1D6e5CF5c",
    BN_GMX: "0x41cD8CaFc24A771031B9eB9C57cFC94D86045eB6",
    USDG: "0x641Ff5D17178C3B9498133eBC264Bb4170A04668",
    ES_GMX_IOU: "0x0000000000000000000000000000000000000000", // placeholder address

    StakedGmxTracker: "0xFfB69477FeE0DAEB64E7dE89B57846aFa990e99C",
    BonusGmxTracker: "0xC2C5968e16ec9fABc39e27f9AbFC07C8Cfba6F16",
    FeeGmxTracker: "0x52cC60893d3Bd8508baAB835620CbF9ddfA0A13C",
    StakedGlpTracker: "0xA30b1C3c8EDE3841dE05F9CdD4D0e097aC4C6D92",
    FeeGlpTracker: "0xCEBC8A8b66De9B3f4393966EaB86Fc9DE26B2529",

    StakedGmxDistributor: "0xa0207802B0953b17421bf9Cb10B3ACf5823496ab",
    StakedGlpDistributor: "0xb54AbE3FEC8e1aE64620185A1E111Aa0c3a81542",

    GmxVesterV1: "0x0000000000000000000000000000000000000000",
    GlpVesterV1: "0x0000000000000000000000000000000000000000",

    GmxVester: "0xfDC9B5be032216315bBe8c06b1c4F563D1689b85",
    GlpVester: "0xB280D03909Cc18640621955Cb3bC30948DF2Fa9a",
    OrderBook: "0xC5129208cb1DC2b3c916011c9D94632e602B9811",
    OrderExecutor: "0x0000000000000000000000000000000000000000",
    OrderBookReader: "0xc592b3ADd24ea30c030978e5E7F5d02E123b4263",

    PositionRouter: "0x01e9B35785eF3f7Ef2677c371442976bd550f320",
    PositionManager: "0x08Dfcfb0bD6e7eAF828f60021C77d273DE56b1C5",

    TraderJoeGmxAvaxPool: "0x104D0312f95A1B3056435d19668f2272ab1e7dF2",//TODO
    ReferralStorage: "0x7B26207457A9F8fF4fd21A7A0434066935f1D8E7",
    ReferralReader: "0xe149164D8eca659E8912DbDEC35E3f7E71Fb5789",

    UniswapGmxEthPool: "0x5d2D9deE001D95Dc6B203d74AA651b6D864a619A", //TODO
    Multicall: "0xeAa6877139d436Dc6d1f75F3aF15B74662617B2C",
    NFTClub: "0x0000000000000000000000000000000000000000",
    MummyClubSale: "0x0000000000000000000000000000000000000000",
    MummyClubStaking: "0x0000000000000000000000000000000000000000",
    NFTSaleV2: "0x0000000000000000000000000000000000000000",
    NFTClubV2: "0x0000000000000000000000000000000000000000",
    MummyClubStakingV2: "0x0000000000000000000000000000000000000000",
    BridgeNFT: "0x0000000000000000000000000000000000000000",
    MigrateVester: "0x0000000000000000000000000000000000000000",
    Bridge: "0x0d8393CEa30df4fAFA7f00f333A62DeE451935C1",
    MultiFeeDistribution: "0xBEb742e42481A329bf160C922Ba5309Bb9F8a86D",
    MMYLP: "0x0000000000000000000000000000000000000000",
    ChefIncetives: "0x5c6C987936539034930CD00fCD8c9Ab8b3458560",
  },
  [MUMBAI]: {
    Vault: "0xA6D7D0e650aa40FFa42d845A354c12c2bc0aB15f",
    Router: "0x41cD8CaFc24A771031B9eB9C57cFC94D86045eB6",
    VaultReader: "0x766257B7cE3a5E3Ad5876200Ab1671D31289BC75",
    Reader: "0xB2a477C6BA5E96f6dECbCEd836cB7d3d32ef9ecD",
    GlpManager: "0x304951d7172bCAdA54ccAC1E4674862b3d5b3d5b",
    RewardRouter: "0x7b9e962dd8AeD0Db9A1D8a2D7A962ad8b871Ce4F",
    RewardReader: "0x4C4d81aA29fBb7Fe90172ad70a72F00Fb1ee46c6",
    NATIVE_TOKEN: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83", //
    GLP: "0x0ce61aAF89500e4f007884fBbf62642618dEf5dd",
    GMX: "0x01e77288b38b416F972428d562454fb329350bAc",
    ES_GMX: "0xe41c6c006De9147FC4c84b20cDFBFC679667343F",
    BN_GMX: "0x0d8393CEa30df4fAFA7f00f333A62DeE451935C1",
    USDG: "0xCaB2C0A41556149330F4223C9b76d93C610DAfE6",
    ES_GMX_IOU: "0x0000000000000000000000000000000000000000", //
    StakedGmxTracker: "0x727dB8FA7861340d49d13ea78321D0C9a1a79cd5",
    BonusGmxTracker: "0x04f23404553fcc388Ec73110A0206Dd2E76a6d95",
    FeeGmxTracker: "0xe149164D8eca659E8912DbDEC35E3f7E71Fb5789",
    StakedGlpTracker: "0xFfB69477FeE0DAEB64E7dE89B57846aFa990e99C",
    FeeGlpTracker: "0x7B26207457A9F8fF4fd21A7A0434066935f1D8E7",

    StakedGmxDistributor: "0xC2C5968e16ec9fABc39e27f9AbFC07C8Cfba6F16",
    StakedGlpDistributor: "0xa0207802B0953b17421bf9Cb10B3ACf5823496ab",

    GmxVester: "0xa1a65D3639A1EFbFB18C82003330a4b1FB620C5a",
    GlpVester: "0x2A3E489F713ab6F652aF930555b5bb3422711ac1",

    OrderBook: "0x9032aeD8C1F2139E04C1AD6D9F75bdF1D6e5CF5c",
    OrderExecutor: "0x0000000000000000000000000000000000000000", //
    OrderBookReader: "0x2Aef1BC2f13118009DF8663705F736F77EFaFD5c",

    PositionRouter: "0x2D270f66feE6Ac9e27Ff6551AF5a8cFB5C8a7493",
    PositionManager: "0x68d1CA32Aee9a73534429D8376743Bf222ff1870",

    UniswapGmxEthPool: "0x855B2EeDA3ffFEabf03b6DbF2609904da2247Cc8", //
    ReferralStorage: "0x28cfD8e1E83beC8EE879d21634e7DC3D93102CED",
    ReferralReader: "0xc592b3ADd24ea30c030978e5E7F5d02E123b4263",
    NFTClub: "0x9e9f0901fde8914f13b2c965aa1538dc557b06a6",
    MummyClubSale: "0x90B8dA33F39F3C2Bf7456b312afE44CfDAc09eEe",
    Multicall: "0x08411ADd0b5AA8ee47563b146743C13b3556c9Cc",
    MummyClubStaking: "0x46bd9B7F2a353A2A5d1Ad92440c0437419113A7b",

    BridgeNFT: "0x57f67286B6D1cE0623766022bCc2fAfE80B32c9a",
    NFTSaleV2: "0x34Cb8892c04c240ae0342f1632565D4EC305f678",
    NFTClubV2: "0xec866016ce430654d823f682491462a2be39014c",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
    MMYLP: "0x0000000000000000000000000000000000000000"
  },
  [FANTOM_TEST]: {
    Vault: "0x7e9E9d925846B110B025041cfdF9942f2C401F4F",
    VaultMMY: "0x6b357844C40EA317bf9a214a93FFf72C658DDd03",
    VaultMLP: "0x29C7b5dC2F24DD26D3962cbCD75A7122bd1706D8",
    VaultMMY_WFTM_OLD: "0x0E3fE9D47c8db3ae68092c942D759BdCDde7eb3A",
    VaultMMY_WFTM: "0x6448600794C29c0B78710c2b12FF3728C9c91c71",
    VaultMMY_WETH: "???",
    Router: "0x6b4E5cbCED6E907Ab8525d83Dd3Cd9Ec6BDb62C4",
    VaultReader: "0x67B8a4A528A0a697491988B12EFbE865f9f20E18",
    Reader: "0xb5546535a3181d24F1e0cea032c696a92407bd4F",
    GlpManager: "0xca057751eDa4FB5BD23766C165555AD12A042202",
    RewardRouter: "0x0ccB273CA9842855636A6aC15bea105Ca05b20c4",
    RewardReader: "0x53418e5D25d1E4Ff176C28866A12b2fC546c357A",
    NATIVE_TOKEN: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83", //
    GLP: "0xAd41EC9dbCd9B4bD59d5EEF3E2be2cB8AAfc5e7e",
    GMX: "0xfDdbf81d31938A3AD3c767F8840863EEbaC4aD03",
    ES_GMX: "0xe41c6c006De9147FC4c84b20cDFBFC679667343F",
    BN_GMX: "0xc7CcA5b6EDC3e2ca3Bae2CCdf6bc4eCA943B7598",
    USDG: "0xd60aeF040e04a1F6b5f33078F18DD580B9A3f3C7",
    ES_GMX_IOU: "0x0000000000000000000000000000000000000000", //
    StakedGmxTracker: "0x2301d1AF7f00FfF41F8ecb250eee399972d23530",
    BonusGmxTracker: "0x2a6da5A53aFD235Ffb0A3569f0AeA841E6Fdc8F2",
    FeeGmxTracker: "0xC52Be971c10f2Ef8d34ED7C5E997dda1705cc292",
    StakedGlpTracker: "0xC35208A29EF948395db0F7e58A9C3293a6f42EB5",
    FeeGlpTracker: "0x11fe19BaBaA706D7B45f54e9F0231b7BA1DB9E4A",

    StakedGmxDistributor: "0x42E0fBa31503DD5c223006eD46bb1Cf25Bf1cd3a",
    StakedGlpDistributor: "0xe91e9279d89f508E8070801df13754304b86EbCE",

    GmxVester: "0x8eF5634F5C6Ef625302Ab6e4C424Dbe6B59496C0",
    GlpVester: "0xDdeaC5Dc3A5352cCa9dD13C3067Cbbdbe2A43700",
    GmxVesterV1: "0xa1a65D3639A1EFbFB18C82003330a4b1FB620C5a",
    GlpVesterV1: "0x2A3E489F713ab6F652aF930555b5bb3422711ac1",

    OrderBook: "0xf564737Ba16695c4a2733Ba9EdDf215D60d9a557",
    OrderExecutor: "0x0000000000000000000000000000000000000000", //
    OrderBookReader: "0xDf933efE492E54D0e7b99b6FD80A37906Ad0E98e",

    PositionRouter: "0x1cA552b930723f5d9CEDD56DBa53F3545215c7a3",
    PositionManager: "0xf342404561D8Ee0364F519aBCd7F18353D20ff5c",

    UniswapGmxEthPool: "0x2A6538a456650Cd454Dcd8f0B4665183DBa0bb27", //
    ReferralStorage: "0xd1FeA2883728330079bB6A6F1c6D332fCf764bAa",
    ReferralReader: "0x9e82f29a0f30584D9A92e93371234B807047c273",
    NFTClub: "0x573235B8e2708C39DD2Fa9Ec2d880121f4F83cA9",
    MummyClubSale: "0x6983249cFBE49eBD2c7fD37d392d69F1aEbE2d11",
    Multicall: "0xcA11bde05977b3631167028862bE2a173976CA11",
    MummyClubStaking: "0xD8e6AF2bE7A928F075a02a32eb65F2B7DfB696ad",
    MummyClubStakingV2: "0x7B25fA4AC6871CcdC2f29451ee0fa6eA01399968",
    LiquidityLocker: "0xcd6Fc0f32Eee391Ec4685c6c2E5c20A19960A804",
    Bridge: "0x4EE33bF422690B38552ec2A39dd942043C944ae8",
    MMYMigration: "0x0000000000000000000000000000000000000000",
    MigrateVester: "0x789eB395b830842c2E091c0B200C69D8c5Bb3D5a",
    BridgeNFT: "0xA6D7D0e650aa40FFa42d845A354c12c2bc0aB15f",
    NFTClubV2: "0x4964795d3F320C4BbfdAA0686a7629Cf92A4B266",
    NFTSaleV2: "0xf93a3F5488836b69735895c1C7843D5AF20CD8DE",
    Faucet: "0x81f3112bD4737d2bB0E4eC55c0dfeB8284573B6a",
    MultiFeeDistribution: "0x6F1F5A5D7F44b00Cce94F20b6093f4a0E37C6dD6",
    ChefIncetives: "0x5c6C987936539034930CD00fCD8c9Ab8b3458560",
    MMYLP: "0x77461EfDf024ddAcca16Fce4D93fb1d6F122E6b7"
  },
};

export function getContract(chainId: number, name: string): string {
  if (!CONTRACTS[chainId]) {
    throw new Error(`Unknown chainId ${chainId}`);
  }

  if (!CONTRACTS[chainId][name]) {
    throw new Error(`Unknown contract "${name}" for chainId ${chainId}`);
  }

  return CONTRACTS[chainId][name];
}
